import * as React from 'react';
import { useConfiguratorContext } from '@grandvisionhq/configurator';
import { useDispatch, useSelector } from '@grandvisionhq/state';
import '../../state/actions.js';
import '../../state/add-to-cart/selectors.js';
import '../../state/bundles/selectors.js';
import '../../state/bundles/reducer.js';
import { getFrameSku, getAdditionalPrescriptionInfoFormState, getVerificationAllowed } from '../../state/configurator/selectors.js';
import '../../state/configurator/reducer.js';
import '../../state/products/selectors.js';
import '../../state/products/reducer.js';
import PrescriptionStepValidationStep from './PrescriptionValidationStep.js';
import { updatePrescriptionInfo, updateVerificationAllowed } from '../../state/configurations/actions.js';

const PrescriptionValidationStepContainer = ()=>{
    const dispatch = useDispatch();
    const { goToNextStep , hasAttemptedNextStep  } = useConfiguratorContext();
    const frameSku = useSelector(getFrameSku);
    const prescriptionInfoFormState = useSelector(getAdditionalPrescriptionInfoFormState);
    const isVerificationAllowed = useSelector(getVerificationAllowed);
    const handleChange = React.useCallback((formState)=>{
        if (!frameSku) {
            return;
        }
        dispatch(updatePrescriptionInfo({
            frameSku,
            value: formState
        }));
    }, [
        frameSku,
        dispatch
    ]);
    const handleIsVerificationAllowedChange = React.useCallback((verificationAllowed)=>{
        if (!frameSku) {
            return;
        }
        dispatch(updateVerificationAllowed({
            frameSku,
            value: verificationAllowed
        }));
    }, [
        frameSku,
        dispatch
    ]);
    return /*#__PURE__*/ React.createElement(PrescriptionStepValidationStep, {
        prescriptionInfoFormState: prescriptionInfoFormState,
        verificationAllowed: isVerificationAllowed,
        onVerificationAllowedChange: handleIsVerificationAllowedChange,
        showValidationError: hasAttemptedNextStep,
        onChange: handleChange,
        onSubmit: goToNextStep
    });
};

export { PrescriptionValidationStepContainer };
//# sourceMappingURL=PrescriptionValidationStepContainer.js.map
